// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__plHz60g7","tab":"Tabs_tab__jm2ZW1fu","active":"Tabs_active__+gCS2E6f"};